import { render } from "./EventRegisterView.vue?vue&type=template&id=5bc6bbc8"
import script from "./EventRegisterView.vue?vue&type=script&lang=js"
export * from "./EventRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__